import { createFileRoute } from '@tanstack/react-router';

import Content from '../-components/Content';

export const Route = createFileRoute('/_authenticated/externalContent/embeds/$id/')({
    component: Content,
});
